import React from "react";
import MicroIcon from "../brand/MicroIcon";
import { COLORS } from "../brand/tokens";

const ImpressumPage = () => {
  return (
    <main className="site-main site-main--cream" data-testid="page-impressum">
      <section className="contact-hero" style={{ paddingBottom: "1rem" }}>
        <MicroIcon size={56} color={COLORS.gold} />
        <p className="eyebrow" style={{ marginTop: "1rem" }}>LEGAL · IMPRESSUM</p>
        <h1>Impressum</h1>
        <p className="lede">
          Angaben gemäß § 5 TMG und § 55 Abs. 2 RStV.
        </p>
      </section>

      <section
        className="impressum-body"
        style={{
          maxWidth: 760,
          margin: "0 auto",
          padding: "2rem 1.5rem 5rem",
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "1.05rem",
          lineHeight: 1.75,
          color: "#3a3229",
        }}
        data-testid="impressum-body"
      >
        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          Anbieterin
        </h2>
        <p>
          <strong>RonaWellness</strong><br />
          Inh. Robinah Allgaier<br />
          München, Deutschland
        </p>

        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          Kontakt
        </h2>
        <p>
          E-Mail:{" "}
          <a href="mailto:hello@ronawellness.shop" style={{ color: COLORS.gold }}>
            hello@ronawellness.shop
          </a>
          <br />
          Website:{" "}
          <a href="https://ronawellness.shop" style={{ color: COLORS.gold }}>
            www.ronawellness.shop
          </a>
        </p>

        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          Umsatzsteuer-Identifikationsnummer
        </h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
          <em>Wird auf Anfrage mitgeteilt / Available upon request</em>
        </p>

        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          Verantwortlich für den Inhalt
        </h2>
        <p>
          Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br />
          Robinah Allgaier<br />
          Anschrift wie oben.
        </p>

        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          EU-Streitschlichtung
        </h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: COLORS.gold }}
          >
            https://ec.europa.eu/consumers/odr
          </a>
          .<br />
          Meine E-Mail-Adresse findest du oben im Impressum.
        </p>

        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          Verbraucherstreitbeilegung
        </h2>
        <p>
          Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          Haftung für Inhalte
        </h2>
        <p>
          Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach
          den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter
          jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>

        <h2 style={{ fontFamily: "'Marcellus', serif", fontSize: "1.4rem", marginTop: "2rem" }}>
          Urheberrecht
        </h2>
        <p>
          Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf diesen Seiten unterliegen
          dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
          Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
          der jeweiligen Autorin.
        </p>

        <p
          style={{
            marginTop: "3rem",
            fontStyle: "italic",
            color: "#7a6b57",
            textAlign: "center",
          }}
        >
          Stand: {new Date().getFullYear()} · RonaWellness · Munich, Germany 🌿
        </p>
      </section>
    </main>
  );
};

export default ImpressumPage;
